/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

export class TaskModel {
  private _taskId?: string;
  private _ownerId?: string;
  private _taskDescription?: string;
  private _taskStatus?: string;
  private _createdDate?: Date;
  private _updatedDate?: Date;
  private _updatedBy?: string;
  private _requiredDate?: Date;
  private _complete?: boolean;
  private _completedDate?: Date;
  private _taskHeading?: string;

  constructor(
    taskId?: string,
    ownerId?: string,
    taskDescription?: string,
    taskStatus?: string,
    createdDate?: Date,
    updatedDate?: Date,
    updatedBy?: string,
    requiredDate?: Date,
    complete?: boolean,
    completedDate?: Date,
    taskHeading?: string
  ) {
    this._taskId = taskId;
    this._ownerId = ownerId;
    this._taskDescription = taskDescription;
    this._taskStatus = taskStatus;
    this._createdDate = createdDate;
    this._updatedDate = updatedDate;
    this._updatedBy = updatedBy;
    this._requiredDate = requiredDate;
    this._complete = complete;
    this._completedDate = completedDate;
    this._taskHeading = taskHeading;
  }

  get taskId(): string {
    return this._taskId;
  }

  set taskId(value: string) {
    this._taskId = value;
  }

  get ownerId(): string {
    return this._ownerId;
  }

  set ownerId(value: string) {
    this._ownerId = value;
  }
  get taskHeading(): string {
    return this._taskHeading;
  }

  set taskHeading(value: string) {
    this._taskHeading = value;
  }
  get taskDescription(): string {
    return this._taskDescription;
  }

  set taskDescription(value: string) {
    this._taskDescription = value;
  }

  get taskStatus(): string {
    return this._taskStatus;
  }

  set taskStatus(value: string) {
    this._taskStatus = value;
  }

  get createdDate(): Date {
    return this._createdDate;
  }

  set createdDate(value: Date) {
    this._createdDate = value;
  }

  get updatedDate(): Date {
    return this._updatedDate;
  }

  set updatedDate(value: Date) {
    this._updatedDate = value;
  }

  get updatedBy(): string {
    return this._updatedBy;
  }

  set updatedBy(value: string) {
    this._updatedBy = value;
  }
  get requiredDate(): Date {
    return this._requiredDate;
  }

  set requiredDate(value: Date) {
    this._requiredDate = value;
  }
  get complete(): boolean {
    return this._complete;
  }

  set complete(value: boolean) {
    this._complete = value;
  }
  get completedDate(): Date {
    return this._completedDate;
  }

  set completedDate(value: Date) {
    this._completedDate = value;
  }

  toJson(): Object {
    const object = {
      task_id: this.taskId,
      owner_id: this.ownerId,
      task_description: this.taskDescription,
      task_status: this.taskStatus,
      created_date: this.createdDate,
      update_date: this.updatedDate,
      updated_by: this.updatedBy,
      required_date: this.requiredDate,
      complete: this.complete,
      completed_date: this.completedDate,
      task_heading: this.taskHeading,
    };
    Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): TaskModel {
    return new TaskModel(
      input['task_id'],
      input['owner_id'],
      input['task_description'],
      input['task_status'],
      input['created_date'],
      input['updated_date'],
      input['updates_by'],
      input['required_date'],
      input['complete'],
      input['completed_date'],
      input['task_heading']
    );
  }
}
